var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgForesightAiLogoEyes = function SvgForesightAiLogoEyes(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 859 522",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#foresight-ai-logo-eyes_svg__a)",
    d: "M808.249.28c28.148 0 50.977 23.474 50.98 52.433v80.973a41.3 41.3 0 0 0-14.995-3.29c-70.449-2.394-157.847 79.215-292.11 133.453-48.914 19.73-101.357 35.595-109.092 37.794-7.708 2.2 47.514 5.962 79.163 9.713 14.375 25.472 35.255 46.412 60.375 60.54 25.122 14.13 53.531 20.902 82.133 19.598 93.548-.002 138.649-59.805 149.59-121.868A189.7 189.7 0 0 0 817 217.618c-.468-.067-41.678-5.731-128.72 14.687 53.97-27.715 100.051-48.707 140.257-50.357v-.315c10.277-.21 20.535.413 30.691 1.779v285.875c-.002 28.958-22.833 52.434-50.98 52.434H50.737c-28.144-.003-50.96-23.478-50.964-52.434V183.601c10.396-1.357 20.897-1.932 31.41-1.653 40.365 1.456 85.949 22.478 140.427 50.357-87.834-20.539-128.705-14.687-128.705-14.687a182.7 182.7 0 0 0 2.523 52.008c11.1 62.063 56.055 121.868 149.605 121.868 28.602 1.338 57.013-5.435 82.133-19.566s45.987-35.094 60.327-60.588c31.68-3.653 86.705-7.464 79.163-9.697-7.574-2.23-60.301-18.08-109.059-37.81C173.81 209.598 85.791 128.138 15.501 130.397c-5.781.131-11.01 1.392-15.73 3.447v-81.13C-.225 23.756 22.592.283 50.737.28Z",
    style: {
      fill: "url(#foresight-ai-logo-eyes_svg__a)",
      strokeWidth: 2.19879
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "foresight-ai-logo-eyes_svg__a",
    x1: 427.61,
    x2: 427.61,
    y1: 282.812,
    y2: -34.404,
    gradientTransform: "matrix(2.16778 0 0 2.23026 -497.462 -12.836)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#287ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A328CC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForesightAiLogoEyes);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;